import React, { useState } from 'react';
import { BookOpen, AlertTriangle, Bookmark, FileText } from 'lucide-react';
import '../../components/study/CardActionsMenu.css';

interface PreviewCardActionsMenuProps {
  hasSupportContent: boolean;
  onToggleSupportContent: () => void;
  onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
  cardId: string;
}

const PreviewCardActionsMenu: React.FC<PreviewCardActionsMenuProps> = ({
  hasSupportContent,
  onToggleSupportContent,
  onShowToast,
  cardId,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };

  const handleLocked = (e: React.MouseEvent, message: string) => {
    e.preventDefault();
    e.stopPropagation();
    onShowToast(message, 'info');
    setIsOpen(false);
  };

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" className="gooey-svg">
        <defs>
          <filter id="gooey-effect">
            <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="10" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
              result="goo"
            />
            <feComposite in2="goo" in="SourceGraphic" result="mix" />
          </filter>
        </defs>
      </svg>

      <nav
        className="card-actions-menu-gooey"
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <input
          type="checkbox"
          className="menu-open-checkbox"
          id={`prev-menu-${cardId}`}
          checked={isOpen}
          onChange={() => setIsOpen(v => !v)}
        />
        <label
          className="menu-open-button"
          htmlFor={`prev-menu-${cardId}`}
          onClick={handleToggle}
          title="Menu"
        >
          <span className="hamburger hamburger-1" />
          <span className="hamburger hamburger-2" />
          <span className="hamburger hamburger-3" />
        </label>

        <div className="gooey-wrapper">
          <button
            className="menu-item menu-item-1"
            onClick={e => handleLocked(e, 'Assine para ver as referências do card')}
            type="button"
            title="Referências"
          >
            <BookOpen size={18} strokeWidth={2.5} />
          </button>

          <button
            className="menu-item menu-item-2 saved-item"
            onClick={e => handleLocked(e, 'Assine para ter funções de salvar flashcards')}
            type="button"
            title="Salvar card"
          >
            <Bookmark size={18} strokeWidth={2.5} fill="none" />
          </button>

          <button
            className="menu-item menu-item-3"
            onClick={e => handleLocked(e, 'Assine para reportar erro neste card')}
            type="button"
            title="Reportar erro"
          >
            <AlertTriangle size={18} strokeWidth={2.5} />
          </button>
        </div>

        <button
          className={`details-btn ${!hasSupportContent ? 'disabled' : ''}`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (hasSupportContent) onToggleSupportContent();
          }}
          disabled={!hasSupportContent}
          type="button"
          aria-label="Conteúdo de apoio"
          data-tooltip="Conteúdo de apoio"
        >
          <FileText size={16} strokeWidth={2.5} />
        </button>
      </nav>
    </>
  );
};

export default PreviewCardActionsMenu;
